import { environment } from '../environment';

export async function downloadBlob(
  blobId: string,
  fileName: string,
  accessToken: string
): Promise<void> {
  const blob = await fetch(`${environment.REST_API_URI}/blobs/${blobId}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  }).then((res) => res.blob());

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');

  a.href = url;
  a.download = fileName;
  a.setAttribute('style', 'display: none;');

  document.body.appendChild(a);

  a.click();
  a.remove();
}
